import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

const TOKENS = [
  { key: "corner_rounding", label: "Corner rounding" },
  { key: "surface", label: "Surface / Panel" },
  { key: "button", label: "Buttons" },
  { key: "card", label: "Cards" },
];

// Per-token "Match Gallery" checkboxes (spec §2). Only shown for surfaces whose
// config.matchGallery is true. value = match_gallery object of bools.
const MatchGalleryToggles = ({ value, onChange, tokens = TOKENS.map((t) => t.key) }) => {
  const mg = value || {};
  return (
    <Box data-testid="match-gallery-toggles" sx={{ mt: 1 }}>
      <Typography sx={{ fontSize: 13, color: "#565556", mb: 0.5, fontFamily: "DM Sans" }}>
        Match Gallery when shown on your Gallery page:
      </Typography>
      {TOKENS.filter((t) => tokens.includes(t.key)).map((t) => (
        <FormControlLabel
          key={t.key}
          control={
            <Checkbox
              size="small"
              data-testid={`match-${t.key}`}
              checked={!!mg[t.key]}
              onChange={(e) => onChange({ ...mg, [t.key]: e.target.checked })}
              sx={{ color: "#9B5AF8", "&.Mui-checked": { color: "#9B5AF8" } }}
            />
          }
          label={<Typography sx={{ fontSize: 13, fontFamily: "DM Sans" }}>{t.label}</Typography>}
        />
      ))}
    </Box>
  );
};

export default MatchGalleryToggles;
